
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/facility-item/[id]/price",
      function () {
        return require("private-next-pages/facility-item/[id]/price.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/facility-item/[id]/price"])
      });
    }
  